import { Config } from '@/config';
import { ApiService } from '@/services/api.service';
import axios from 'axios';

const CancelToken = axios.CancelToken;
const cancelTokens = {
  directions: null,
  recompute: null,
};

class OpportunityMobilizationsService {
  getOpportunityMobilizationDirections({ opportunityId, mobilizationId }) {
    if (cancelTokens.directions) {
      cancelTokens.directions.cancel('Multiple requests.');
    }
    cancelTokens.directions = CancelToken.source();

    return ApiService.get(
      `${Config.api.document.url}api/v1/opportunities/${opportunityId}/mobilizations/${mobilizationId}/directions`,
      {
        cancelToken: cancelTokens.directions.token,
      },
    ).then((response) => response.data);
  }

  recomputeOpportunityMobilizations({ opportunityId }) {
    if (cancelTokens.recompute) {
      cancelTokens.recompute.cancel('Multiple requests.');
    }
    cancelTokens.recompute = CancelToken.source();

    return ApiService.post(
      `${Config.api.document.url}api/v1/opportunities/${opportunityId}/mobilizations/recompute`,
      {},
      {
        cancelToken: cancelTokens.recompute.token,
      },
    ).then((response) => response.data);
  }
}

export const opportunityMobilizationsService = new OpportunityMobilizationsService();
